import { render, staticRenderFns } from "./selectTree2.vue?vue&type=template&id=edb3e232&scoped=true"
import script from "./selectTree2.vue?vue&type=script&lang=js"
export * from "./selectTree2.vue?vue&type=script&lang=js"
import style0 from "./selectTree2.vue?vue&type=style&index=0&id=edb3e232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb3e232",
  null
  
)

export default component.exports